var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_165",
    "data-name": "Group 165",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a8cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#60acef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89c0ef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(80 80) rotate(180)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MDI_file-cloud",
    "data-name": "MDI / file-cloud",
    transform: "translate(21.247 21.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.43,
    height: 38.43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37.43,
    height: 37.43,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_file-cloud",
    "data-name": "Path / file-cloud",
    d: "M20.943,14H31.3L20.943,4.571V14M7.765,2h15.06l11.3,10.283V32.848a3.608,3.608,0,0,1-3.765,3.428H7.765A3.607,3.607,0,0,1,4,32.848V5.428A3.6,3.6,0,0,1,7.765,2M25.988,24.279a6.943,6.943,0,0,0-6.928-5.141,7.172,7.172,0,0,0-6.25,3.428,5.393,5.393,0,0,0-5.045,5.141,5.412,5.412,0,0,0,5.648,5.141H25.649a4.51,4.51,0,0,0,4.706-4.284A4.515,4.515,0,0,0,25.988,24.279Z",
    transform: "translate(0.155 0.077)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCloud);
export default __webpack_public_path__ + "static/media/file-cloud.4705b3ae5dd7888d8433de792419b887.svg";
export { ForwardRef as ReactComponent };